import * as React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import Cover from '../components/Cover/Cover';
import Image from '../components/Image/Image';
import Intro from '../components/Intro/Intro';
import Main from '../components/Main/Main';
import Case, { StoryFrame } from '../Entities/Case';
import ContentfulCase from '../Entities/Contentful/ContentfulCase';
import Site from '../Entities/Site';
import getMetaDescription from '../utils/getMetaDescription';
import mapCase from '../utils/mapCase';

interface Props {
  data: {
    site: Site;
    contentfulCase: ContentfulCase;
  };
}

interface State {
  coverHeight: number;
}

const Grid = styled.div`
  // background: #fff;
  // padding: 1rem;
`;

const GridItem = styled.div`
  margin-bottom: 1rem;
`;

const GridContent = styled.div`
  padding: 1rem;
  text-align: center;

  h2 {
    margin: 0;
  }

  @media (min-width: 700px) and (max-width: 800px) {
    p {
      font-size: 0.8rem;
    }
  }
`;

export default class extends React.PureComponent<Props, State> {
  private case: Case = mapCase(this.props.data.contentfulCase);

  constructor(props: Props) {
    super(props);

    this.state = {
      coverHeight: 0
    };

    this.handleCoverHeight = this.handleCoverHeight.bind(this);
  }

  public render() {
    if (!this.case) {
      return <div>Sorry, but the case was not found</div>;
    }
    return (
      <div>
        <Helmet
          title={`${this.case.title} - Elesthorp`}
          meta={[
            {
              content: getMetaDescription(this.case.description || this.case.title),
              name: 'description'
            }
          ]}
        />
        {this.case.image && <Cover image={this.case.image} getHeight={this.handleCoverHeight} />}
        <Main coverHeight={this.state.coverHeight}>
          <Intro title={this.case.title} description={this.case.description} />
          {this.case.stories && (
            <Grid>
              {this.case.stories.map((story: StoryFrame, index: number) => (
                <GridItem key={index}>
                  <Image {...story.image} />
                  {story.title &&
                    story.description && (
                      <GridContent>
                        <h2>{story.title}</h2>
                        <div dangerouslySetInnerHTML={{ __html: story.description }} />
                      </GridContent>
                    )}
                </GridItem>
              ))}
            </Grid>
          )}
        </Main>
      </div>
    );
  }

  private handleCoverHeight(height: number) {
    this.setState({ coverHeight: height });
  }
}

export const caseQuery = graphql`
  query caseQuery($id: String!) {
    contentfulCase(id: { eq: $id }) {
      id
      title
      description {
        childMarkdownRemark {
          html
        }
      }
      media {
        file {
          fileName
          url
        }
        sizes(maxWidth: 1400, quality: 100) {
          src
          srcSet
          aspectRatio
          sizes
        }
      }
      stories {
        title
        description {
          childMarkdownRemark {
            html
          }
        }
        media {
          file {
            fileName
            url
          }
          sizes(maxHeight: 800, quality: 100) {
            src
            srcSet
            aspectRatio
            sizes
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/case.tsx